/**
 * @generated SignedSource<<57b602456fe0a9b1ec0cfd12ff2ce05b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateProctorMutation$variables = {
  firstName?: string | null;
  key: string;
  lastName?: string | null;
  regionIds?: ReadonlyArray<string | null> | null;
  state?: string | null;
};
export type CreateProctorMutation$data = {
  readonly createProctor: {
    readonly firstName: string | null;
    readonly id: string;
    readonly key: string;
    readonly lastName: string | null;
    readonly regions: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly state: string | null;
  };
};
export type CreateProctorMutation = {
  response: CreateProctorMutation$data;
  variables: CreateProctorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "firstName",
            "variableName": "firstName"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          },
          {
            "kind": "Variable",
            "name": "lastName",
            "variableName": "lastName"
          },
          {
            "kind": "Variable",
            "name": "regionIds",
            "variableName": "regionIds"
          },
          {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Proctor",
    "kind": "LinkedField",
    "name": "createProctor",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateProctorMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateProctorMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "e9cbf7860f04fa56c5e111a57dc2970d",
    "id": null,
    "metadata": {},
    "name": "CreateProctorMutation",
    "operationKind": "mutation",
    "text": "mutation CreateProctorMutation(\n  $key: String!\n  $firstName: String\n  $lastName: String\n  $state: String\n  $regionIds: [ID]\n) {\n  createProctor(input: {key: $key, firstName: $firstName, lastName: $lastName, state: $state, regionIds: $regionIds}) {\n    id\n    key\n    firstName\n    lastName\n    state\n    regions {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "139df9aff9fe0403df653bf8a8f1f786";

export default node;
